"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSR_DATA = exports.JWT_HASH = exports.DEFAULT_ENDPOINT = void 0;
var SSR_DATA = {
  synonyms: [{
    name: 'ALGO_ONE',
    value: ['SSI5', 'SPAK', 'SMD7', 'SKLB', 'SXAI']
  }, {
    name: 'ALGO_TWO',
    value: ['SRX5', 'SRDJ', 'SLAK', 'SKD7', 'SBZ2']
  }, {
    name: 'ALGO_THREE',
    value: ['SPGR', 'SMDJ', 'SMXT', 'SZQZ', 'SLXT']
  }, {
    name: 'ALGO_FOUR',
    value: ['SSXT', 'SLZ2', 'SRXT', 'SAI5', 'SBI5']
  }, {
    name: 'ALGO_FIVE',
    value: ['SLD7', 'SQXJ', 'SOXT', 'SBFD', 'SYXT']
  }, {
    name: 'ALGO_SIX',
    value: ['SLUM', 'SQAI', 'SORM', 'SBOH', 'SYAM']
  }],
  api_data: [{
    source: 'booking',
    id: 'sdlkd2l3'
  }, {
    source: 'details',
    id: 'eue3kds'
  }, {
    source: 'checkout',
    id: 'wxesdumi'
  }, {
    source: 'search',
    id: 'xmncx278'
  }, {
    source: 'smartfill',
    id: 'wiuwejk2'
  }]
};
exports.SSR_DATA = SSR_DATA;
var JWT_HASH = '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f';
exports.JWT_HASH = JWT_HASH;
var DEFAULT_ENDPOINT = 'smartfill';
exports.DEFAULT_ENDPOINT = DEFAULT_ENDPOINT;